export const OPEN_LEAD_PREVIEW = 'OPEN_LEAD_PREVIEW';
export const CLOSE_LEAD_PREVIEW = 'CLOSE_LEAD_PREVIEW';
